
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwtMr3duyV6N2jjh0gyGEvafaq7VuByp0GihDweT_M5sZ0Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseid54amtK10XugGFwpILURbY2293vUkORyQ52t0knbknW0Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as depositiLZAWTs20m8gjmZMMA8cISV3T3i80dhD9UQcnLWQItMMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45usT0UokDo4WlZ9qCyn77KHJvxx_45hw2RtysRntHDiUMiMUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93WL_kUA2OvaWOOMScoKIk6BIXxK4oPyUOcS6MBRURhcAMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_93DVQcTYmlKC1VXsyy7MSozEioeSloNgjjgcmN4XMnKsoMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fundAryciSEGRfEL9d61IAYQCGmy8ARuRIfvjgzzTHioNtAMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexacF3HA2CdWdLQNjRLcU308Cs1VrLeAmBGFdcVzYyKn4Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseidjZfzw1O7_45PY6CQvSeTayl_45p1HPvxcX4BZGy2HM78DSQMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountn08g0Mq_DHHBzbC7ep_w6_451iew1dHNNwXXMPsK_45owqkMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blockedatqqCKAr0R2It4jcCTflo1bbAV0qFbqA1akfPsmuvVUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referralEfgM4QnXtky60Waqp7IC2FhEgUUD_45xPqJTNx56JT8W8Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityRPApDRIQN5Z0Vopn_45uUit_45vviU61gYg2UbPWIEONexQMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outnjibJSFXrw5xhx_VMCbnJS6lXL0nJkXKcHSeUCF3AKcMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_93Tt3aVBmbntg7AyUr7wJ4TUAERQMDyc42i3wB_vAAIaQMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_93h_45lXiWmaYyFB96AHq90Bqi11UrlaSG2G0D7SGBhHYaUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawezXJ6AGgrWhKxuap6c02JK3D9wkPS_8_nFk7Im5bdgIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardFhIF_dVuNLc0bvtxZBkvpuTphT4hDxDsBqk34uJl_45okMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developer69Bm8VqL_9jLOtaGDeqsz0_45quyrvUgXqEErUmvISMg0Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginaqn22n5e5vFAlODGWaDlhrDb40oZfdYYLDc11JXt1gIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingLkx8DJVY0KfJSGjP_45yUmJVuyDKkkLlfqt4sj_457JEapAMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundMObarRV3KE7qAYSBYCRnaFhb9bZKeGco5bn4vpZ_45CCoMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2faKTI670EGuTWdJ3Kn_b_jRP9qVDFwHc069qLhc5rD7YUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexB4JkL0QwNHfsZ0_Fk3BcoAAMP_9inMlcOunzCt2NjpcMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codewc2nFfM1AE85DahhklTUDhNVmNGnq3yBnd4ds_45AkvxgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as codezG66FW6I5Vzs3dUt3WdPdas7SkQC_45_vw82Fpr2tROcsMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexZXtUe0b_45NicNo4hkuZ8bZu8kLf3bgPmTQqy16hVr8J4Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerEFElqL3oVtyOOaq27HOOGvbr2SFel1hf2yaruGanZrsMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexzuLjlyGyBMhs_45q94PvXcmc9N8dfXpbnX7MSU4yNWYx4Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93l1QS3bLiezzr7Pxq8FChTJnDB374YZh5FJ9aSOaJZJUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexNoJVycC_lsgBL86UiK2jWcoPQEVzaO_9zJLNj71_kkIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45documentzIuNGQdtq5mkJHrX_Wx6A7GNEGnZ_Q1IHS5YTvRP688Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as indexOQQHd3jyh2DuMz_P7E9zYwhDfNhcT8yo3vvKgeTeSsQMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexV6fq8cOwtVBwVe7C0JgzR5BAvyP_g7FgKZBBfRQo9ycMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importVYICjjTywh5Awfsrnzgp9inXBOYXHnRjyFkoSf7ggOAMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directIed8pi8Gc5nR7vnb8Pgfo0Fntl0OGKac_45L_45S8fjUgLQMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubdbync4Qi9fyr4Fcr_45_6CJVSQUvDeAZfJswr0ZBUJQ_45sMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedYOCLzofOKDeodmidUAVwZIioRe8Qld796n2MlI1NsvUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedkjlP4sdlz31Pko_bE6a2T5_JGB9RUlN4yVrJz_qnaIEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightf4KylztBBJJBjqBZYvh6m_xDHm6b2t3e8eilP52XkGUMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightLSlAmVrvq4b_Bnn9b39NH_456dIdQJhP_FuqdpfYm9slkMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as invite_UB2RQQq0EgAbcga_FPb_Sta6wQ2VpKvDOpsqvjQJZ8Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexkU2ZfhPs4bhEnwT1_0xCggC96Srf4f8XhMtBXCpLslkMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexonIqQ137n_45WtWSgRRbuDZR_8F0InVjrLiMXYvLKA7NEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waitingz_C4z8l6KzpNu6Bp2s_8VJlIfX3B_ZGBHyoQ_457498Y0Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as businessG_45FJQr2pZtslc1rFOCH7lVu_45B56tKa8wvcQJmi7O4ewMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbackol9ppqlggQp_45QDROadOPKAqDPHN_tygXWqIULw1m7iYMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93wn6I8qv3yIgbIjAHxCzrGZkgJ59kjRGatmioBBQcejEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as indexZNBNIbbcRb2v2H1JJ48SKWXTgQ_NgVvjQb8VV2CIEScMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93g5_JSfU_B8w21Tlk27u6pPosAmPAF_45erxra0DjAWlpEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as index6fgPwolrG6aQYJsUe9stWaK0BRXt0_45tnjldsFtextTEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexh_fF_ICE6dbhLSVcEFDc7zxv6v0UpOGHK_J_zb0RhwgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexsw8n5TbJvM6GxpuchSg4Bprrd7C2zPRBqEQFdqE7vJ8Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as options0gP89hOzlG77AWALCgVVT42gMvSaXu9sPpewAl18e6AMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdraw9cQNKJS0eR5M9XL0MCu6NDG3wGCzwY4x3mk2xd0KgnAMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_93jQzH28CWqjzJYZBJKBePUBWnMMbek7rUEamkDJq1hLgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as indexg_45FDZPCGzRaCW_nCoL_1PCFtGyHyZtd52lXQjsQlCpkMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexXQuARdcfRN4Pq_siceQUIdCYBh6NZbc2lX2QhB1VfwgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as indexsULIzGElVkEjYnL7Dni_Y7odOAzC9Qsm9_i07DGjni8Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as ramps0BG8HJ_456dj3sAa0yqAN4hODVkrjYHBlytfI9qsOAhswMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classificatione6WCi_45VGRlSdcEWI4uNB0sGrjTxNPoNBol_5XHVNnV4Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93V6DKtcuHyKXv_45oEdlwzaX_kjcq7w_LnRZilP79NM4o0Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45walletSdvOgmUS2AJ_45sOwQjG19cQvTP1WyRcD7z1GCaM7Mm1AMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45address_45PEtxneTQtuNHxngMqRmgNPmbd7_z3fS6hVJ288fKqoMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsqQbjdjn5lZWtDZr2Go1_454UNge_45F6tdRbF5e2E_LmF1kMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45historyoWxTMIzmN4XNB1su_45VHIQGkhk2J8AKB3w_45cS6FnEkOMMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usRyJZsIevYqAiTbgXw60c44yPQVmkbkNk8J_453JFuIrfYMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurWRYuGNYeo9RErn6N0EYzcWEdLiLR78flvpSI0ExzFiIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbpEml6kOD6aI37VXPL7M3D0uDXenu_456VDjAmzc64QlM4MMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngn_45_4525rDZMWNv8c1VYbKEtl_45oIW33_45JSr0N9QBeUEwraEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlaxqIblCSYNtZUliA8YbSAVNu8Ky2vIfq46UkwTvhOmJ4Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexs6ITwOo9_hBCBrOk1ADB__45dtDstplS88LZapB5n2YdgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakenLE2Ww9I_452X2WVtQVDYSkKuo5CuvuMTdDj33cvDkj9jMMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binance408zkEXYGqUU_45_4KoJGCAP3V84Jm3w7LldoTx0VGoYEMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaseFcrtcDT7J8NLRqMTX23qstRi3G08K2rG5jIMmCPaUJsMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationalP_Cpje9N3qciSge20DCDKokoyk4npIyxs0_45mUFVDXsoMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_walletlJSSonKeOdoTcDZiz_Yce_xUn36FEZ1SFrlU95AIaiIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankwp7ngSwHjQIKBQYR4NlEPxPzf1jQBCEsaGNCBzFL8PgMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as index6fy_45QMBsF_452BZef7raoQ_45rWnZ6T8hPlP1xayEQUziywMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_93Z9PcU2qOSakfpBpbaRA2zo9fE0VhIAnJeMJiAlcUtDIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as optionsnmMK95YyOfX1J9ZdzcVioe8C3lM6gDHnSiASSd4L4ysMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbaseGdy4qC3Tv22kRv9cQbnnmn28sie_jKf9y9t9BcN3s6IMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamcn7AGoXPeHjos_454TQeeEltZ2dIAQTjsbJ79UFBz8L70Meta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_932xapXrzT3ISYlyTcQVpEUM7lwcrCX0rC_45Y0t1g6wp8IMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexJpZJO_45Zb6LAt4AEx6dDwUwkvEIdqXhgZcuWIbpbu55oMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletbOANDJbdquRxTGrSyg_9jYqKdNSkrlOqvftBWBQxkJIMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_schedulebbTkL9nKtyWlWQ6oT3C0fYDfozIXJdKdfUchDtV8D1AMeta } from "/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwtMr3duyV6N2jjh0gyGEvafaq7VuByp0GihDweT_M5sZ0Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundAryciSEGRfEL9d61IAYQCGmy8ARuRIfvjgzzTHioNtAMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseid54amtK10XugGFwpILURbY2293vUkORyQ52t0knbknW0Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: depositiLZAWTs20m8gjmZMMA8cISV3T3i80dhD9UQcnLWQItMMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45usT0UokDo4WlZ9qCyn77KHJvxx_45hw2RtysRntHDiUMiMUMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93WL_kUA2OvaWOOMScoKIk6BIXxK4oPyUOcS6MBRURhcAMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_93DVQcTYmlKC1VXsyy7MSozEioeSloNgjjgcmN4XMnKsoMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexacF3HA2CdWdLQNjRLcU308Cs1VrLeAmBGFdcVzYyKn4Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidjZfzw1O7_45PY6CQvSeTayl_45p1HPvxcX4BZGy2HM78DSQMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountn08g0Mq_DHHBzbC7ep_w6_451iew1dHNNwXXMPsK_45owqkMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockedatqqCKAr0R2It4jcCTflo1bbAV0qFbqA1akfPsmuvVUMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referralEfgM4QnXtky60Waqp7IC2FhEgUUD_45xPqJTNx56JT8W8Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityRPApDRIQN5Z0Vopn_45uUit_45vviU61gYg2UbPWIEONexQMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outnjibJSFXrw5xhx_VMCbnJS6lXL0nJkXKcHSeUCF3AKcMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawezXJ6AGgrWhKxuap6c02JK3D9wkPS_8_nFk7Im5bdgIMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardFhIF_dVuNLc0bvtxZBkvpuTphT4hDxDsBqk34uJl_45okMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developer69Bm8VqL_9jLOtaGDeqsz0_45quyrvUgXqEErUmvISMg0Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingLkx8DJVY0KfJSGjP_45yUmJVuyDKkkLlfqt4sj_457JEapAMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexB4JkL0QwNHfsZ0_Fk3BcoAAMP_9inMlcOunzCt2NjpcMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexZXtUe0b_45NicNo4hkuZ8bZu8kLf3bgPmTQqy16hVr8J4Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexzuLjlyGyBMhs_45q94PvXcmc9N8dfXpbnX7MSU4yNWYx4Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexNoJVycC_lsgBL86UiK2jWcoPQEVzaO_9zJLNj71_kkIMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45documentzIuNGQdtq5mkJHrX_Wx6A7GNEGnZ_Q1IHS5YTvRP688Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexOQQHd3jyh2DuMz_P7E9zYwhDfNhcT8yo3vvKgeTeSsQMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importVYICjjTywh5Awfsrnzgp9inXBOYXHnRjyFkoSf7ggOAMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: invite_UB2RQQq0EgAbcga_FPb_Sta6wQ2VpKvDOpsqvjQJZ8Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexkU2ZfhPs4bhEnwT1_0xCggC96Srf4f8XhMtBXCpLslkMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexonIqQ137n_45WtWSgRRbuDZR_8F0InVjrLiMXYvLKA7NEMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingz_C4z8l6KzpNu6Bp2s_8VJlIfX3B_ZGBHyoQ_457498Y0Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: businessG_45FJQr2pZtslc1rFOCH7lVu_45B56tKa8wvcQJmi7O4ewMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93wn6I8qv3yIgbIjAHxCzrGZkgJ59kjRGatmioBBQcejEMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexZNBNIbbcRb2v2H1JJ48SKWXTgQ_NgVvjQb8VV2CIEScMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93g5_JSfU_B8w21Tlk27u6pPosAmPAF_45erxra0DjAWlpEMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: index6fgPwolrG6aQYJsUe9stWaK0BRXt0_45tnjldsFtextTEMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexh_fF_ICE6dbhLSVcEFDc7zxv6v0UpOGHK_J_zb0RhwgMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexsw8n5TbJvM6GxpuchSg4Bprrd7C2zPRBqEQFdqE7vJ8Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: options0gP89hOzlG77AWALCgVVT42gMvSaXu9sPpewAl18e6AMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdraw9cQNKJS0eR5M9XL0MCu6NDG3wGCzwY4x3mk2xd0KgnAMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93jQzH28CWqjzJYZBJKBePUBWnMMbek7rUEamkDJq1hLgMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: indexg_45FDZPCGzRaCW_nCoL_1PCFtGyHyZtd52lXQjsQlCpkMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexXQuARdcfRN4Pq_siceQUIdCYBh6NZbc2lX2QhB1VfwgMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indexsULIzGElVkEjYnL7Dni_Y7odOAzC9Qsm9_i07DGjni8Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: ramps0BG8HJ_456dj3sAa0yqAN4hODVkrjYHBlytfI9qsOAhswMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificatione6WCi_45VGRlSdcEWI4uNB0sGrjTxNPoNBol_5XHVNnV4Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93V6DKtcuHyKXv_45oEdlwzaX_kjcq7w_LnRZilP79NM4o0Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsqQbjdjn5lZWtDZr2Go1_454UNge_45F6tdRbF5e2E_LmF1kMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45historyoWxTMIzmN4XNB1su_45VHIQGkhk2J8AKB3w_45cS6FnEkOMMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: optionsnmMK95YyOfX1J9ZdzcVioe8C3lM6gDHnSiASSd4L4ysMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamcn7AGoXPeHjos_454TQeeEltZ2dIAQTjsbJ79UFBz8L70Meta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_932xapXrzT3ISYlyTcQVpEUM7lwcrCX0rC_45Y0t1g6wp8IMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexJpZJO_45Zb6LAt4AEx6dDwUwkvEIdqXhgZcuWIbpbu55oMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletbOANDJbdquRxTGrSyg_9jYqKdNSkrlOqvftBWBQxkJIMeta || {},
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh1210/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]